const DUTCH_MONTHS = [
  "jan", "feb", "mrt", "apr", "mei", "jun",
  "jul", "aug", "sep", "okt", "nov", "dec",
];

const toDate = (timestamp) => {
  if (!timestamp) return null;
  if (typeof timestamp.toDate === "function") return timestamp.toDate();
  if (timestamp instanceof Date) return timestamp;
  return null;
};

const isSameDay = (a, b) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

// "11:07" when the conversation is from today, otherwise "25 mei".
const formatConversationTime = (timestamp, now = new Date()) => {
  const date = toDate(timestamp);
  if (!date) return "";

  if (isSameDay(date, now)) {
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  }

  return `${date.getDate()} ${DUTCH_MONTHS[date.getMonth()]}`;
};

export default formatConversationTime;
